import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ENDPOINTS = deepFreeze({
    SPACES_COMPETITION_REPORT: {
        URI: () => '/api/v1/spaces/{{spaceId}}/competition-report',
        methods: ['get'],
    },
    SPACES_COMPETITION_REPORT_EXPORT: {
        URI: () => '/api/v1/spaces/{{spaceId}}/competition-report-export',
        methods: ['get', 'post'],
    },
    COMPETITION_REPORT_EXPORT: {
        URI: () => '/api/v1/competition-report-export/{{spaceId}}',
        methods: ['get'],
    },
    COMPETITION_REPORT_EXPORT_DOWNLOAD: {
        URI: () => '/api/v1/competition-report-export/{{spaceId}}/download',
        methods: ['get'],
    },
    SPACES_COMPETITION_REPORT_SET: {
        URI: () => '/api/v1/spaces/{{spaceId}}/competition-report-set',
        methods: ['get', 'post'],
        cacheToClear: ['/api/v1/competition-report-set/\\d+', '/api/v1/spaces/{{spaceId}}/competition-report'],
    },
    COMPETITION_REPORT_SET: {
        URI: () => '/api/v1/competition-report-set/{{id}}',
        methods: ['get', 'patch', 'delete'],
        cacheToClear: ['/api/v1/spaces/\\d+/competition-report-set', '/api/v1/spaces/\\d+/competition-report'],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
